/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */

//loading css  https://www.youtube.com/shorts/sqFOv1NzGUQ

//ran this thru claudes code refactoring tool


// Give me the complete code with instructions


// [PASTE COMPONENT HERE]

// A few tips for specific component types:

// Cards / product tiles — add "use card pattern: white bg, rounded-2xl, shadow-sm, hover:shadow-md hover:scale-[1.02] transition-all"
// Modals / drawers — add "use frosted glass: bg-white/95 backdrop-blur-sm, rounded-3xl, shadow-2xl"
// Forms / inputs — add "inputs should be rounded-2xl, border with primaryColor+'30', focus ring using primaryColor+'40'"
// Tables / lists — add "rows use hover:bg-primaryColor+'08', active row uses primaryColor+'12' background"
// Toasts / alerts — add "rounded-2xl, shadow-md, soft tinted background matching severity (rose for error, emerald for success)"
// The most important line to always include is:


// redesign this component to look more elegant and polished and add accents
// use tailwind css in the className directive 
// Use Tailwind CSS in className only. Preserve all logic, Redux hooks, and routing exactly as-is.
// "Colors come from dynamic seller props — use hex + opacity string concatenation (e.g. sellerPrimaryColor1 + '20') for tints, never hardcode colors."
// give me the entire code to copy any insrtuctions to implement
// ask me a series of questions to gather additional context you need to best achive this task



import React, { useEffect, useState, useMemo, lazy, Suspense } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { IoIosArrowForward } from "react-icons/io";
import { FaHeart, FaTwitter } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa";
import { MdOutlineRestaurantMenu } from "react-icons/md";
import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
import { FaUser } from "react-icons/fa6";

import Header from '../components/Header';
import Footer from '../components/Footer';
import ShopBanner from '../components/ShopBanner';
import SwiperProducts from '../components/products/SwiperProducts';
import GetSellerConfig from '../components/GetSellerConfig';

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import { get_product_details } from '../store/reducers/homeReducer';
import { add_to_cart, add_to_wishlist, messageClear } from '../store/reducers/cartReducer';

import { currencyFormat } from '../components/CurrencyFormat';
import SkeletonWithImage from '../components/SkeletonWithImage';
import SiteBadge from '../components/SiteBadge';
import toast from 'react-hot-toast';
import config from '../config';

const Rating   = lazy(() => import('../components/Rating'));
const Reviews  = lazy(() => import('../components/Reviews'));
const Products = lazy(() => import('../components/products/Products'));

const chunkArray = (arr, size) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
        chunks.push(arr.slice(i, i + size));
    }
    return chunks;
};

const Details = () => {
    const sellerBoolShowStock = config.BOOL_SHOW_PRODUCT_STOCK;

    const { seller }                          = useSelector(state => state.seller);
    const { userInfo }                        = useSelector(state => state.auth);
    const { errorMessage, successMessage }    = useSelector(state => state.cart);
    const { product, relatedProducts, moreProducts } = useSelector(state => state.home);
    const { sellerComponentBackgroundColor, sellerBoolShowKosher } = GetSellerConfig();

    const sellerId             = seller?._id;
    const sellerPrimaryColor1  = seller?.frontEndPrimaryColor1;
    const sellerPrimaryColor2  = seller?.frontEndPrimaryColor2;
    const sellerSecondaryColor1 = seller?.frontEndSecondaryColor1;

    const sellerArrHexOpacityColorSuffixes = seller?.hexOpacityColorSuffixes?.split(';') || [];
    const sellerColorSuffixDark   = sellerArrHexOpacityColorSuffixes[0] || 'FF';
    const sellerColorSuffixMedium = sellerArrHexOpacityColorSuffixes[1] || '80';
    const sellerColorSuffixLight  = sellerArrHexOpacityColorSuffixes[2] || '1A';

    const sellerShoppingTerm          = seller?.shoppingTerm;
    const sellerProductTerm           = seller?.productTerm;
    const sellerProductPluralTerm     = seller?.productPluralTerm;
    const sellerCompanyMarketingLine1 = seller?.marketingLine1;

    const bools = useMemo(() => ({
        showPayments:          seller?.isVisibleSitePayments === 'Show',
        showWishList:          seller?.isVisibleSiteWishlist === 'Show',
        showSocialMedia:       seller?.isVisibleSiteSocialMedia === 'Show',
        showRating:            seller?.isVisibleSiteRating === 'Show',
        showProductQuantities: seller?.isVisibleSiteProductQuantities === 'Show',
        showProductReviews:    seller?.isVisibleSiteProductReviews === 'Show',
        showChat:              seller?.isVisibleSiteChat === 'Show',
        showCookingMethods:    seller?.isVisibleSiteCookingMethods === 'Show',
        showCuisineType:       seller?.isVisibleSiteCuisineType === 'Show',
        showHoliday:           seller?.isVisibleSiteHoliday === 'Show',
    }), [seller]);

    const [portionSize, setPortionSize] = useState('');
    const [quantity, setQuantity]       = useState(1);
    const [isProductDescriptionExpanded, setIsProductDescriptionExpanded] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { slug } = useParams();

    useEffect(() => {
        dispatch(get_product_details(slug));
    }, [slug, dispatch]);

    useEffect(() => {
        if (successMessage) {
            toast.success(successMessage);
            setPortionSize('');
            dispatch(messageClear());
        }
        if (errorMessage) {
            toast.error(errorMessage);
            setPortionSize('');
            dispatch(messageClear());
        }
    }, [successMessage, errorMessage, dispatch]);

    const responsive = {
        superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 5 },
        desktop:           { breakpoint: { max: 3000, min: 1024 }, items: 5 },
        tablet:            { breakpoint: { max: 1024, min: 464 },  items: 4 },
        mdtablet:          { breakpoint: { max: 991,  min: 464 },  items: 4 },
        mobile:            { breakpoint: { max: 464,  min: 0 },    items: 3 },
        smmobile:          { breakpoint: { max: 640,  min: 0 },    items: 2 },
        xsmobile:          { breakpoint: { max: 440,  min: 0 },    items: 1 },
    };

    const chunkedMoreProducts = useMemo(() => chunkArray(moreProducts, 3), [moreProducts]);

    const cartProductQuantityIncrementLocal = () => {
        if (quantity >= product.stock) {
            toast.error('Out of Stock');
        } else {
            setQuantity(q => q + 1);
        }
    };
    const cartProductQuantityDecrementLocal = () => {
        if (quantity > 1) setQuantity(q => q - 1);
    };

    const redirect_chat_page = (chatTopic) => {
        navigate(userInfo ? `/customerDashboard/chat/${chatTopic}` : '/login');
    };

    const add_to_cart_local = (productId) => {
        if (userInfo) {
            dispatch(add_to_cart({ userId: userInfo.id, quantity, productId, portionSize }));
            setPortionSize('');
        } else {
            navigate('/login');
        }
    };

    const add_to_wishlist_local = () => {
        if (userInfo) {
            dispatch(add_to_wishlist({
                userId:       userInfo.id,
                productId:    product._id,
                name:         product.name,
                price:        product.price,
                image:        product.images[0],
                discount:     product.discount,
                rating:       product.rating,
                slug:         product.slug,
                portionSizes: product.portionSizes,
                description:  product.description,
                byThePan:     product.byThePan,
            }));
        } else {
            navigate('/login');
        }
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <Header />

            {/* ── Breadcrumb ── w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] mx-auto py-0 */}
            <section className="">
                <div className="">
                    <ShopBanner
                        homePage={'Home'}
                        homeLink={'/'}
                        currentPageTop={sellerProductTerm + ' Details'}
                        currentPageTopLink={''}
                        currentPageBottom1={product.category}
                        currentPageBottomLink1={'/productsCategory?category=' + product.category}
                        currentPageBottom2={product.name}
                        currentPageBottomLink2={''}
                    />
                </div>
            </section>

            {/* ── Main product section ── */}
            <section className="py-10"
                style={{ backgroundColor: sellerComponentBackgroundColor }}>
                <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] mx-auto">
                    <div className="grid grid-cols-2 md-lg:grid-cols-1 gap-8 items-start">

                        {/* ── Left: image card ── */}
                        <div className="flex flex-col gap-4">
                            {/* Hero image card */}
                            <div className="p-4 rounded-2xl bg-white">
                                <div
                                    className="relative rounded-2xl overflow-hidden bg-white p-4 border"
                                    style={{ 
                                        borderTopColor: sellerPrimaryColor1 + sellerColorSuffixDark, 
                                        borderTopWidth: '6px', 
                                        borderBottomColor: sellerPrimaryColor1 + sellerColorSuffixDark,
                                        borderRightColor: sellerPrimaryColor1 + sellerColorSuffixDark,
                                        borderLeftColor: sellerPrimaryColor1 + sellerColorSuffixDark
                                    }}>
                                    <img
                                        className="w-full h-[360px] object-cover rounded-xl"
                                        src={product?.images?.[0]}
                                        alt={product.name}
                                    />
                                    {/* Accent badge / marketing line */}
                                    {sellerCompanyMarketingLine1 && (
                                        <div className="flex mt-2">
                                            <SiteBadge iconType={'Menu'} iconSize={'40'} badgeSize={'52'} />
                                            <div
                                                className="mt-0 text-start text-md italic font-medium tracking-wide py-1.5 px-3 rounded-full"
                                                style={{
                                                    color: sellerPrimaryColor1 + sellerColorSuffixDark,
                                                }}>
                                                {sellerCompanyMarketingLine1}
                                            </div>
                                        </div>
                                        
                                    )}
                                </div>

                                {/* Thumbnail carousel */}
                                {product.images && product.images?.[1] && (
                                    <div className="hidden mt-2 rounded-xl overflow-hidden">
                                        <Carousel autoPlay={true} infinite={true} responsive={responsive} transitionDuration={500}>
                                            {product.images.map((img, i) => (
                                                <div key={i} className="px-1">
                                                    <SkeletonWithImage
                                                        className="h-[100px] w-full object-cover rounded-lg cursor-pointer ring-2 ring-transparent hover:ring-offset-2 transition-all duration-200"
                                                        style={{ '--tw-ring-color': sellerPrimaryColor1 }}
                                                        src={img}
                                                        alt=""
                                                    />
                                                </div>
                                            ))}
                                        </Carousel>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* ── Right: product info ──  */}
                        <div className="p-4 rounded-2xl bg-white">
                            <div className="flex flex-col gap-4 bg-white rounded-2xl border p-4"
                                style={{ 
                                    borderTopColor: sellerPrimaryColor1 + sellerColorSuffixDark, 
                                    borderTopWidth: '6px',
                                    borderBottomColor: sellerPrimaryColor1 + sellerColorSuffixDark,
                                    borderRightColor: sellerPrimaryColor1 + sellerColorSuffixDark,
                                    borderLeftColor: sellerPrimaryColor1 + sellerColorSuffixDark 
                                }}>
                                {/* Name */}
                                <div>
                                    <div className="flex items-center gap-1.5 border-none border-black">
                                        <div
                                            className="w-[6px] h-8 rounded-full"
                                            style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixMedium }}
                                        />
                                        <div
                                            className="text-3xl font-bold tracking-tight leading-tight"
                                            style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                            {product.name}
                                        </div>
                                    </div>
                                    {/* Thin color accent underline */}
                                    <div
                                        className="hidden mt-2 h-[3px] w-14 rounded-full"
                                        style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}
                                    />
                                </div>
                                <div className={` ${bools.showPayments || bools.showRating ? '' : 'hidden'} 
                                    flex gap-1 border-none border-red-500`}>
                                    {/* Price */}
                                    {bools.showPayments && (
                                        <div
                                            className="inline-flex items-center gap-2 text-2xl font-bold px-4 py-2 rounded-xl w-fit"
                                            style={{
                                                color: sellerPrimaryColor1 + sellerColorSuffixDark,
                                                backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
                                            }}>
                                            {currencyFormat.format(product.price)}
                                        </div>
                                    )}    
                                    {/* Rating */}
                                    {bools.showRating && (
                                        <div className="flex items-center gap-2">
                                            <Suspense fallback={null}>
                                                <Rating ratings={4.5} />
                                            </Suspense>
                                        </div>
                                    )}
                                </div>
                                <div
                                    className="text-sm leading-relaxed rounded-xl px-3 py-2 border-l-4 whitespace-pre-wrap transition-all duration-300 relative"
                                    style={{
                                        color: sellerPrimaryColor1 + sellerColorSuffixDark,
                                        borderLeftColor: sellerPrimaryColor1 + sellerColorSuffixMedium,
                                        backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
                                        maxHeight: isProductDescriptionExpanded ? 'none' : '120px',
                                        overflowY: isProductDescriptionExpanded ? 'visible' : 'auto',
                                    }}>
                                    <div className="flex justify-start mb-0.5">
                                        <button
                                            onClick={() => setIsProductDescriptionExpanded(prev => !prev)}
                                            className="flex items-center gap-0.5 text-xs font-medium px-1 py-0.5 border 
                                            rounded-md transition-all duration-200"
                                            style={{
                                                color: sellerPrimaryColor1 + sellerColorSuffixDark,
                                                backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
                                                borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
                                            }}>
                                            {isProductDescriptionExpanded ? (
                                                <>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M18 15l-6-6-6 6"/></svg>
                                                    Collapse
                                                </>
                                            ) : (
                                                <>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9l6 6 6-6"/></svg>
                                                    Expand
                                                </>
                                            )}
                                        </button>
                                    </div>

                                    <div className="border-none border-black">
                                        {product.description || ''}
                                    </div>
                                </div>
                                
                                {/* Product details strip */}
                                <div
                                    className="rounded-xl px-3 py-1 text-sm leading-relaxed border-l-4 space-y-0.5"
                                    style={{
                                        color: sellerPrimaryColor1 + sellerColorSuffixDark,
                                        borderLeftColor: sellerPrimaryColor1 + sellerColorSuffixMedium,
                                        backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
                                    }}>
                                    <span className="font-semibold">{sellerProductTerm} Details: </span>
                                    { sellerBoolShowKosher && product.FMP && <span>{product.FMP}; </span> }
                                    <span>Category: <b>{product.category}</b>; </span>
                                    <span className={product.allergies !== 'None' ? 'font-semibold text-red-500' : ''}>
                                        Allergies: <b>{product.allergies}</b>;{' '}
                                    </span>
                                    {bools.showCookingMethods && (
                                        <span>Cooking Method: <b>{product.cookingMethod}</b>; </span>
                                    )}
                                    {product.byThePan !== 'NoPan' && (
                                        <span>By The Pan: <b>{product.byThePan}</b>; </span>
                                    )}
                                    {product.dietaryRestrictions !== 'None' && (
                                        <span>Dietary Restrictions: <b>{product.dietaryRestrictions}</b>; </span>
                                    )}
                                    {bools.showCuisineType && (
                                        <span>Cuisine Type: <b>{product.cuisineType}</b>; </span>
                                    )}
                                    {bools.showHoliday && product.holiday !== 'None' && (
                                        <span>Holiday: <b>{product.holiday}</b></span>
                                    )}
                                </div>

                                {/* Divider */}
                                <div className="border-t"
                                    style={{ borderColor: sellerPrimaryColor1 + sellerColorSuffixMedium }} />
                                
                                <div className="flex gap-2">
                                    {/* Quantity stepper */}
                                    {bools.showProductQuantities && (
                                        <div className="flex items-center gap-4">
                                            <span className="text-md font-medium"
                                                style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                                Quantity
                                            </span>
                                            <div
                                                className="flex items-center rounded-xl border-2 overflow-hidden"
                                                style={{ 
                                                    borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
                                                    color: sellerPrimaryColor1 + sellerColorSuffixDark,
                                                    backgroundColor: sellerPrimaryColor1 +  + sellerColorSuffixLight,
                                                }}>
                                                <button
                                                    onClick={cartProductQuantityDecrementLocal}
                                                    className="w-9 h-9 flex items-center justify-center text-lg font-bold transition-colors duration-200 hover:opacity-80"
                                                    style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                                    −
                                                </button>
                                                <span
                                                    className="w-10 text-center text-sm font-bold"
                                                    style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                                    {quantity}
                                                </span>
                                                <button
                                                    onClick={cartProductQuantityIncrementLocal}
                                                    className="w-9 h-9 flex items-center justify-center text-lg font-bold transition-colors duration-200 hover:opacity-80"
                                                    style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                                    +
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                    {/* Portion size select */}
                                    {product.portionSizes && (
                                        <select
                                            onChange={(e) => setPortionSize(e.target.value)}
                                            className="w-full h-[42px] px-4 py-2 rounded-xl border-2 text-sm font-semibold 
                                            outline-none transition-colors duration-200 cursor-pointer"
                                            style={{
                                                borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
                                                color: sellerPrimaryColor1 + sellerColorSuffixDark,
                                                backgroundColor: sellerPrimaryColor1 +  + sellerColorSuffixLight,
                                            }}>
                                            <option value="">Choose Portion Size</option>
                                            {product.portionSizes.split(';').map((p, i) => (
                                                <option key={i} value={p}>{p}</option>
                                            ))}
                                        </select>
                                    )}
                                </div>

                                {/* CTAs — Add to cart (solid pill) + Wishlist (ghost pill) + chat */}
                                <div className="grid grid-cols-2 sm:grid-cols-1 gap-1 items-center justify-center justify-items-center">
                                    <button
                                        onClick={() => add_to_cart_local(product._id)}
                                        className="h-[32px] w-[150px] px-0.5 flex items-center justify-center gap-1 rounded-xl text-sm 
                                        font-semibold border-2 text-white transition-all duration-200 active:translate-y-0"
                                        style={{ 
                                            backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark, 
                                            borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
                                        }}>
                                        {userInfo
                                            ? <><MdOutlineRestaurantMenu size={20} /> Add To {sellerShoppingTerm}</>
                                            : <><FaUser size={20} /> Please Login Or Register</>
                                        }
                                    </button>

                                    {bools.showWishList && (
                                        <button
                                            onClick={add_to_wishlist_local}
                                            className="h-[32px] w-[150px] flex items-center justify-center gap-1 rounded-xl text-sm 
                                            font-semibold border-2 transition-all duration-200 active:translate-y-0"
                                            style={{
                                                borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
                                                color: sellerPrimaryColor1 + sellerColorSuffixDark,
                                                backgroundColor: sellerPrimaryColor1 +  + sellerColorSuffixLight,
                                            }}>
                                            <FaHeart size={18} /> Add To Wishlist
                                        </button>
                                    )}
                                </div>
                                <div className='items-center justify-center justify-items-center'>
                                    {/* Chat button */}
                                    {bools.showChat && (
                                        <button
                                            onClick={() => redirect_chat_page(product.name)}
                                            className="h-[32px] w-[150px] flex items-center justify-center gap-1 rounded-xl text-sm 
                                            font-semibold border-2 transition-all duration-200 active:translate-y-0"
                                            style={{ 
                                                borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
                                                color: sellerPrimaryColor1 + sellerColorSuffixDark,
                                                backgroundColor: sellerPrimaryColor1 +  + sellerColorSuffixLight, 
                                            }}>
                                            <IoChatbubbleEllipsesSharp size={20} /> Chat With Us
                                        </button>
                                    )}
                                </div>

                                {/* Availability + social */}
                                <div className="flex items-start gap-6 pt-1">
                                    {sellerBoolShowStock && (
                                        <div className="flex flex-col gap-1">
                                            <span className="text-xs font-semibold uppercase tracking-widest text-gray-400">Availability</span>
                                            <span
                                                className={`text-sm font-semibold ${product.stock ? 'text-emerald-500' : 'text-red-500'}`}>
                                                {product.stock ? `In Stock (${product.stock})` : 'Out Of Stock'}
                                            </span>
                                        </div>
                                    )}

                                    {bools.showSocialMedia && (
                                        <div className="flex flex-col gap-2">
                                            <span className="text-xs font-semibold uppercase tracking-widest text-gray-400">Share</span>
                                            <ul className="flex gap-2">
                                                <li>
                                                    <a
                                                        href="#"
                                                        className="w-9 h-9 flex items-center justify-center rounded-full text-white text-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md"
                                                        style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                                                        <FaFacebookF />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        href="#"
                                                        className="w-9 h-9 flex items-center justify-center rounded-full text-white text-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md"
                                                        style={{ backgroundColor: sellerPrimaryColor1 +  sellerColorSuffixDark }}>
                                                        <FaTwitter />
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ── Reviews + sidebar ── */}
            {bools.showProductReviews && (
                <section className="py-10 bg-white border-t border-gray-100"
                    style={{ backgroundColor: sellerComponentBackgroundColor }}>
                    {/* ── Horizontal rule before bottom bar ── */}
                    <div
                        className="mt-4 mb-4 h-px w-full"
                        style={{
                            background: `linear-gradient(to right, transparent 0%, ${sellerPrimaryColor1}${sellerColorSuffixMedium} 20%, ${sellerPrimaryColor1}${sellerColorSuffixMedium} 80%, transparent 100%)`,
                        }}
                    />

                    <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] mx-auto">
                        <div className="flex flex-wrap gap-6">
                            <div className="w-[73%] md-lg:w-full">
                                <Suspense fallback={null}>
                                    <Reviews product={product} />
                                </Suspense>
                            </div>
                            <div className="w-[24%] md-lg:w-full">
                                {moreProducts.length > 0 && (
                                    <div
                                        className="rounded-2xl p-0 border-none border-gray-100"
                                        style={{ borderTopColor: sellerPrimaryColor1, borderTopWidth: '3px' }}>
                                        <Suspense fallback={null}>
                                            <Products
                                                title='From Our Menu'
                                                products={chunkedMoreProducts}
                                                parentPage='productDetails'
                                            />
                                        </Suspense>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            )}

            {/* ── Related products ── */}
            <section className="py-2 border-none border-black"
                style={{ backgroundColor: sellerComponentBackgroundColor}}>
                <SwiperProducts
                    title={`Related ${sellerProductPluralTerm} You Might Like`}
                    products={relatedProducts}
                    suppressToasts={true}
                />
            </section>

            <Footer />
        </div>
    );
};

export default Details;



//refactored
// import React, { useEffect, useState, useMemo, lazy, Suspense } from 'react';
// import { Link, useNavigate, useParams } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { IoIosArrowForward } from "react-icons/io";
// import { FaHeart, FaTwitter } from "react-icons/fa6";
// import { FaFacebookF } from "react-icons/fa";
// import { MdOutlineRestaurantMenu } from "react-icons/md";
// import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
// import { FaUser } from "react-icons/fa6";

// import Header from '../components/Header';
// import Footer from '../components/Footer';
// import ShopBanner from '../components/ShopBanner';
// import SwiperProducts from '../components/products/SwiperProducts';

// import Carousel from 'react-multi-carousel';
// import 'react-multi-carousel/lib/styles.css';

// import { get_product_details } from '../store/reducers/homeReducer';
// import { add_to_cart, add_to_wishlist, messageClear } from '../store/reducers/cartReducer';

// import { currencyFormat } from '../components/CurrencyFormat';
// import SkeletonWithImage from '../components/SkeletonWithImage';
// import toast from 'react-hot-toast';
// import config from '../config';

// const Rating   = lazy(() => import('../components/Rating'));
// const Reviews  = lazy(() => import('../components/Reviews'));
// const Products = lazy(() => import('../components/products/Products'));

// const chunkArray = (arr, size) => {
//     const chunks = [];
//     for (let i = 0; i < arr.length; i += size) {
//         chunks.push(arr.slice(i, i + size));
//     }
//     return chunks;
// };

// const Details = () => {
//     const sellerBoolShowStock = config.BOOL_SHOW_PRODUCT_STOCK;

//     const { seller }                          = useSelector(state => state.seller);
//     const { userInfo }                        = useSelector(state => state.auth);
//     const { errorMessage, successMessage }    = useSelector(state => state.cart);
//     const { product, relatedProducts, moreProducts } = useSelector(state => state.home);

//     const sellerId             = seller?._id;
//     const sellerPrimaryColor1  = seller?.frontEndPrimaryColor1;
//     const sellerPrimaryColor2  = seller?.frontEndPrimaryColor2;
//     const sellerSecondaryColor1 = seller?.frontEndSecondaryColor1;

//     const sellerArrHexOpacityColorSuffixes = seller?.hexOpacityColorSuffixes?.split(';') || [];
//     const sellerColorSuffixDark   = sellerArrHexOpacityColorSuffixes[0] || 'FF';
//     const sellerColorSuffixMedium = sellerArrHexOpacityColorSuffixes[1] || '80';
//     const sellerColorSuffixLight  = sellerArrHexOpacityColorSuffixes[2] || '1A';

//     const sellerShoppingTerm          = seller?.shoppingTerm;
//     const sellerProductTerm           = seller?.productTerm;
//     const sellerProductPluralTerm     = seller?.productPluralTerm;
//     const sellerCompanyMarketingLine1 = seller?.marketingLine1;

//     const bools = useMemo(() => ({
//         showPayments:          seller?.isVisibleSitePayments === 'Show',
//         showWishList:          seller?.isVisibleSiteWishlist === 'Show',
//         showSocialMedia:       seller?.isVisibleSiteSocialMedia === 'Show',
//         showRating:            seller?.isVisibleSiteRating === 'Show',
//         showProductQuantities: seller?.isVisibleSiteProductQuantities === 'Show',
//         showProductReviews:    seller?.isVisibleSiteProductReviews === 'Show',
//         showChat:              seller?.isVisibleSiteChat === 'Show',
//         showCookingMethods:    seller?.isVisibleSiteCookingMethods === 'Show',
//         showCuisineType:       seller?.isVisibleSiteCuisineType === 'Show',
//         showHoliday:           seller?.isVisibleSiteHoliday === 'Show',
//     }), [seller]);

//     const tooltipHoverStyle = { color: 'white', backgroundColor: sellerPrimaryColor1 };

//     const [portionSize, setPortionSize] = useState('');
//     const [quantity, setQuantity]       = useState(1);

//     const navigate = useNavigate();
//     const dispatch = useDispatch();
//     const { slug } = useParams();

//     useEffect(() => {
//         dispatch(get_product_details(slug));
//     }, [slug, dispatch]);

//     useEffect(() => {
//         if (successMessage) {
//             toast.success(successMessage);
//             setPortionSize('');
//             dispatch(messageClear());
//         }
//         if (errorMessage) {
//             toast.error(errorMessage);
//             setPortionSize('');
//             dispatch(messageClear());
//         }
//     }, [successMessage, errorMessage, dispatch]);

//     const responsive = {
//         superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 5 },
//         desktop:           { breakpoint: { max: 3000, min: 1024 }, items: 5 },
//         tablet:            { breakpoint: { max: 1024, min: 464 },  items: 4 },
//         mdtablet:          { breakpoint: { max: 991,  min: 464 },  items: 4 },
//         mobile:            { breakpoint: { max: 464,  min: 0 },    items: 3 },
//         smmobile:          { breakpoint: { max: 640,  min: 0 },    items: 2 },
//         xsmobile:          { breakpoint: { max: 440,  min: 0 },    items: 1 },
//     };

//     const chunkedMoreProducts = useMemo(() => chunkArray(moreProducts, 3), [moreProducts]);

//     const cartProductQuantityIncrementLocal = () => {
//         if (quantity >= product.stock) {
//             toast.error('Out of Stock');
//         } else {
//             setQuantity(q => q + 1);
//         }
//     };
//     const cartProductQuantityDecrementLocal = () => {
//         if (quantity > 1) setQuantity(q => q - 1);
//     };

//     const redirect_chat_page = (chatTopic) => {
//         navigate(userInfo ? `/customerDashboard/chat/${chatTopic}` : '/login');
//     };

//     const add_to_cart_local = (productId) => {
//         if (userInfo) {
//             dispatch(add_to_cart({ userId: userInfo.id, quantity, productId, portionSize }));
//             setPortionSize('');
//         } else {
//             navigate('/login');
//         }
//     };

//     const add_to_wishlist_local = () => {
//         if (userInfo) {
//             dispatch(add_to_wishlist({
//                 userId:       userInfo.id,
//                 productId:    product._id,
//                 name:         product.name,
//                 price:        product.price,
//                 image:        product.images[0],
//                 discount:     product.discount,
//                 rating:       product.rating,
//                 slug:         product.slug,
//                 portionSizes: product.portionSizes,
//                 description:  product.description,
//                 byThePan:     product.byThePan,
//             }));
//         } else {
//             navigate('/login');
//         }
//     };

//     const actionRowCls = 'grid grid-cols-2 md-lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1 gap-2';

//     return (
//         <div>
//             <Header />
//             <section>
//                 <div className='py-2 mb-2' style={{ color: sellerPrimaryColor1 }}>
//                     <div className='w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto'>
//                         <ShopBanner
//                             homePage={'Home'}
//                             homeLink={'/'}
//                             currentPageTop={sellerProductTerm + ' Details'}
//                             currentPageTopLink={''}
//                             currentPageBottom1={product.category}
//                             currentPageBottomLink1={'/productsCategory?category=' + product.category}
//                             currentPageBottom2={product.name}
//                             currentPageBottomLink2={''}
//                         />
//                     </div>
//                 </div>
//             </section>

//             <section>
//                 <div className='w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto'>
//                     <div className='grid grid-cols-2 md-lg:grid-cols-1 gap-4'>

//                         {/* ── Left: image gallery ── */}
//                         <div>
//                             <div className='p-5 border'>
//                                 <img
//                                     className='h-[320px]'
//                                     src={product?.images?.[0]}
//                                     alt={product.name}
//                                 />
//                                 <div className='italic' style={{ color: sellerPrimaryColor1 }}>
//                                     {sellerCompanyMarketingLine1}
//                                 </div>
//                             </div>
//                             <div className='py-3'>
//                                 {product.images && product.images?.[1] && (
//                                     <Carousel autoPlay={true} infinite={true} responsive={responsive} transitionDuration={500}>
//                                         {product.images.map((img, i) => (
//                                             <div key={i}>
//                                                 <SkeletonWithImage
//                                                     className='h-[120px] w-[100px] object-cover cursor-pointer'
//                                                     src={img}
//                                                     alt=""
//                                                 />
//                                             </div>
//                                         ))}
//                                     </Carousel>
//                                 )}
//                             </div>
//                         </div>

//                         {/* ── Right: product info ── */}
//                         <div className='flex flex-col gap-2 border-none p-2'>
//                             <div className='text-3xl font-bold'>
//                                 <h3 style={{ color: sellerPrimaryColor1 }}>{product.name}</h3>
//                             </div>

//                             {/* Rating */}
//                             {bools.showRating && (
//                                 <div className='flex justify-start items-center gap-2'>
//                                     <div className='flex text-xl'>
//                                         <Suspense fallback={null}>
//                                             <Rating ratings={4.5} />
//                                         </Suspense>
//                                     </div>
//                                 </div>
//                             )}

//                             {/* Price */}
//                             {bools.showPayments && (
//                                 <div className='text-2xl font-bold flex gap-2' style={{ color: sellerPrimaryColor1 }}>
//                                     Price: {currencyFormat.format(product.price)}
//                                 </div>
//                             )}

//                             {/* Description */}
//                             <div>
//                                 <textarea
//                                     readOnly
//                                     cols="30"
//                                     rows="5"
//                                     className='border outline-0 w-full'
//                                     style={{ color: sellerPrimaryColor1 }}
//                                     value={product.description || ''}
//                                 />
//                             </div>

//                             {/* Product details strip */}
//                             <div
//                                 className='gap-2 p-1 border'
//                                 style={{ color: sellerPrimaryColor1, borderColor: sellerPrimaryColor1, backgroundColor: sellerSecondaryColor1 }}
//                             >
//                                 <span className='font-semibold'>{sellerProductTerm} Details: </span>
//                                 {product.FMP && <span>{product.FMP};</span>}
//                                 <span className='ml-1 mr-1'>Category: <b>{product.category}</b>;</span>
//                                 <span className={product.allergies !== 'None' ? 'ml-1 mr-1 font-semibold text-red-500' : ''}>
//                                     Allergies: <b>{product.allergies}</b>;
//                                 </span>
//                                 {bools.showCookingMethods && (
//                                     <span className='ml-1 mr-1'>Cooking Method: <b>{product.cookingMethod}</b>;</span>
//                                 )}
//                                 {product.byThePan !== 'NoPan' && (
//                                     <span className='ml-1 mr-1'>By The Pan: <b>{product.byThePan}</b></span>
//                                 )}
//                                 {product.dietaryRestrictions !== 'None' && (
//                                     <span className='ml-1 mr-1'>Dietary Restrictions: <b>{product.dietaryRestrictions}</b></span>
//                                 )}
//                                 {bools.showCuisineType && (
//                                     <span className='ml-1 mr-1'>Cuisine Type: <b>{product.cuisineType}</b></span>
//                                 )}
//                                 {bools.showHoliday && product.holiday !== 'None' && (
//                                     <span className='mr-1'>Holiday: <b>{product.holiday}</b></span>
//                                 )}
//                             </div>

//                             {/* Add to cart / wishlist */}
//                             <div className={actionRowCls}>
//                                 <button
//                                     onClick={() => add_to_cart_local(product._id)}
//                                     className='px-1 py-1 h-[34px] flex w-full rounded-lg text-md cursor-pointer justify-center items-center text-white'
//                                     style={{ backgroundColor: sellerPrimaryColor1 }}
//                                 >
//                                     {userInfo
//                                         ? <><MdOutlineRestaurantMenu className='mr-1' /> Add To {sellerShoppingTerm}</>
//                                         : <><FaUser className='mr-1' /> Please Login Or Register</>
//                                     }
//                                 </button>
//                                 {bools.showWishList && (
//                                     <button
//                                         onClick={add_to_wishlist_local}
//                                         className='h-[34px] w-full rounded-lg flex justify-center items-center cursor-pointer text-white'
//                                         style={{ backgroundColor: sellerPrimaryColor1 }}
//                                     >
//                                         <FaHeart className='mr-1' />Add To Wishlist
//                                     </button>
//                                 )}
//                             </div>

//                             {/* Chat / portion size */}
//                             <div className={actionRowCls}>
//                                 {bools.showChat && (
//                                     <button
//                                         onClick={() => redirect_chat_page(product.name)}
//                                         className='px-1 py-1 flex h-[34px] w-full justify-center items-center rounded-lg cursor-pointer text-white'
//                                         style={{ backgroundColor: sellerPrimaryColor1 }}
//                                     >
//                                         <IoChatbubbleEllipsesSharp className='mr-1' />Chat With Us
//                                     </button>
//                                 )}
//                                 {product.portionSizes && (
//                                     <select
//                                         onChange={(e) => setPortionSize(e.target.value)}
//                                         className='flex border px-3 rounded-lg text-[13px] w-full h-[34px] font-semibold'
//                                         style={{ borderColor: sellerPrimaryColor1, color: sellerPrimaryColor1, backgroundColor: sellerSecondaryColor1 }}
//                                     >
//                                         <option value=''>Choose Portion Size</option>
//                                         {product.portionSizes.split(';').map((p, i) => (
//                                             <option key={i} value={p}>{p}</option>
//                                         ))}
//                                     </select>
//                                 )}
//                             </div>

//                             {/* Quantity stepper */}
//                             {bools.showProductQuantities && (
//                                 <div
//                                     className='flex border rounded-lg w-[90px] h-[34px] ml-1 justify-center items-center'
//                                     style={{ borderColor: sellerPrimaryColor1, backgroundColor: sellerSecondaryColor1 }}
//                                 >
//                                     <div onClick={cartProductQuantityDecrementLocal} className='px-2 cursor-pointer text-[15px] font-semibold' style={{ color: sellerPrimaryColor1 }}>-</div>
//                                     <div className='px-2 text-[15px] font-semibold' style={{ color: sellerPrimaryColor1 }}>{quantity}</div>
//                                     <div onClick={cartProductQuantityIncrementLocal} className='px-2 cursor-pointer text-[15px] font-semibold' style={{ color: sellerPrimaryColor1 }}>+</div>
//                                 </div>
//                             )}

//                             {/* Availability + social share */}
//                             <div className='flex py-2 gap-2'>
//                                 <div className='w-[150px] text-black font-bold text-xl flex flex-col gap-5'>
//                                     {sellerBoolShowStock && <span>Availability</span>}
//                                     {bools.showSocialMedia && (
//                                         <span className='ml-4' style={{ color: sellerPrimaryColor1 }}>Share On</span>
//                                     )}
//                                 </div>
//                                 <div className='flex flex-col gap-2'>
//                                     {sellerBoolShowStock && (
//                                         <span className={`text-${product.stock ? 'green' : 'red'}-500`}>
//                                             {product.stock ? `In Stock(${product.stock})` : 'Out Of Stock'}
//                                         </span>
//                                     )}
//                                     {bools.showSocialMedia && (
//                                         <ul className='flex justify-start items-center gap-3'>
//                                             <li>
//                                                 <a className='w-[38px] h-[38px] hover:bg-[#059473] hover:text-white flex justify-center items-center bg-indigo-500 rounded-full text-white' href="#">
//                                                     <FaFacebookF />
//                                                 </a>
//                                             </li>
//                                             <li>
//                                                 <a className='w-[38px] h-[38px] hover:bg-[#059473] hover:text-white flex justify-center items-center bg-cyan-500 rounded-full text-white' href="#">
//                                                     <FaTwitter />
//                                                 </a>
//                                             </li>
//                                         </ul>
//                                     )}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>

//             {/* Reviews + sidebar */}
//             {bools.showProductReviews && (
//                 <section>
//                     <div className='w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto'>
//                         <div className='flex flex-wrap border-none border-black'>
//                             <div className='w-[75%] md-lg:w-full border-none'>
//                                 <Suspense fallback={null}>
//                                     <Reviews product={product} />
//                                 </Suspense>
//                             </div>
//                             <div className='w-[25%] md-lg:w-full border-none'>
//                                 {moreProducts.length > 0 && (
//                                     <div className='pl-1 md-lg:pl-0'>
//                                         <Suspense fallback={null}>
//                                             <Products
//                                                 title='From Our Menu'
//                                                 products={chunkedMoreProducts}
//                                                 parentPage='productDetails'
//                                             />
//                                         </Suspense>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>
//                     </div>
//                 </section>
//             )}

//             <section>
//                 <SwiperProducts
//                     title={`Related ${sellerProductPluralTerm} You Might Like`}
//                     products={relatedProducts}
//                     suppressToasts={true}
//                 />
//             </section>

//             <Footer />
//         </div>
//     );
// };

// export default Details;



//my original code
// import React, { useEffect, useState, lazy }  from 'react';
// import { Link, useNavigate, useParams } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { IoIosArrowForward } from "react-icons/io";
// import { FaHeart, FaTwitter } from "react-icons/fa6"; 
// import { FaLinkedin, FaGithub, FaFacebookF, FaEye, FaRegHeart  } from "react-icons/fa";
// import { MdOutlineRestaurantMenu } from "react-icons/md";
// import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
// import { FaUser } from "react-icons/fa6";

// import SwiperProducts from '../components/products/SwiperProducts';

// import Carousel from 'react-multi-carousel'; 
// import 'react-multi-carousel/lib/styles.css'

// import { get_product_details } from '../store/reducers/homeReducer';
// import { add_to_cart, add_to_wishlist, messageClear } from '../store/reducers/cartReducer';

// import { currencyFormat } from '../components/CurrencyFormat';
// import SkeletonWithImage from '../components/SkeletonWithImage';
// import toast from 'react-hot-toast';

// import config from '../config';

// const Header  = lazy(()=> import('../components/Header')) 
// const Footer  = lazy(()=> import('../components/Footer')) 
// const Rating  = lazy(()=> import('../components/Rating')) 
// const Reviews  = lazy(()=> import('../components/Reviews')) 
// const ShopBanner  = lazy(()=> import('../components/ShopBanner')) 
// const Products    = lazy(() => import('../components/products/Products'));

// const Details = () => {
//     const sellerBoolShowStock = config.BOOL_SHOW_PRODUCT_STOCK

//     const { seller } = useSelector(state => state.seller)
//     const { userInfo } = useSelector(state => state.auth)
//     const { errorMessage, successMessage } = useSelector(state => state.cart)
//     const { product, relatedProducts, moreProducts } = useSelector(state => state.home)
//     //console.log('product ', moreProducts)

//     const sellerId = seller?._id 
//     const sellerPrimaryColor1 = seller?.frontEndPrimaryColor1
//     const sellerPrimaryColor2 =  seller?.frontEndPrimaryColor2
//     const sellerSecondaryColor1 = seller?.frontEndSecondaryColor1

//     const sellerArrHexOpacityColorSuffixes = seller?.hexOpacityColorSuffixes?.split(';') || [];// 'FF;80;1A' Darkest is FF, Medium is 80, Lightest is 1A
//     const sellerColorSuffixDark = sellerArrHexOpacityColorSuffixes[0] || 'FF';
//     const sellerColorSuffixMedium = sellerArrHexOpacityColorSuffixes[1] || '80';
//     const sellerColorSuffixLight = sellerArrHexOpacityColorSuffixes[2] || '1A';
    
//     const sellerShoppingTerm = seller?.shoppingTerm
//     const sellerProductTerm = seller?.productTerm
//     const sellerProductPluralTerm = seller?.productPluralTerm
//     const sellerCompanyMarketingLine1 = seller?.marketingLine1

//     const sellerBoolShowSitePayments = seller?.isVisibleSitePayments === 'Show' ? true : false
//     const sellerBoolShowSiteWishList = seller?.isVisibleSiteWishlist === 'Show' ? true : false
//     const sellerBoolShowSiteSocialMedia = seller?.isVisibleSiteSocialMedia === 'Show' ? true : false
//     const sellerBoolShowSiteRating = seller?.isVisibleSiteRating === 'Show' ? true : false
//     const sellerBoolShowSiteProductQuantities = seller?.isVisibleSiteProductQuantities === 'Show' ? true : false
//     const sellerBoolShowSiteProductReviews = seller?.isVisibleSiteProductReviews === 'Show' ? true : false
//     const sellerBoolShowSiteChat = seller?.isVisibleSiteChat === 'Show' ? true : false
//     const sellerBoolShowSiteCookingMethods = seller?.isVisibleSiteCookingMethods === 'Show' ? true : false
//     const sellerBoolShowCuisineType = seller?.isVisibleSiteCuisineType === 'Show' ? true : false
//     const sellerBoolShowSiteHoliday = seller?.isVisibleSiteHoliday === 'Show' ? true : false
    
//     const chunkArray = (arr, size) => {
//         const chunks = [];
//         for (let i = 0; i < arr.length; i += size) {
//             chunks.push(arr.slice(i, i + size));
//         }
//         return chunks;
//     };

//     const tooltipHoverStyle = {
//         color: 'white',
//         backgroundColor: sellerPrimaryColor1
//     };

//     const [modalProduct, setModalProduct] = useState(null);
//     const openModal = (product) => {
//         //console.log('product ', product)
//         setModalProduct(product);
//     };
//     const closeModal = () => {
//         setModalProduct(null);
//     };

//     const [image, setImage] = useState('')
//     //const [state, setState] = useState('reviews') //from kazi
//     const [portionSize, setPortionSize] = useState('')
    
//     //const {productId} = useParams() // comes in as undefined
//     const navigate = useNavigate()
//     const dispatch = useDispatch()
//     const {slug} = useParams() //really productId
//     //console.log('productId ', productId)//, 'slug', slug)
    
//     useEffect(() => {
//         dispatch(get_product_details(slug)) //slug is productId
//         //console.log('slug ', slug)
//     },[slug])

//     useEffect(() => { 
//         if (successMessage) {
//             toast.success(successMessage)
//             setPortionSize('')
//             dispatch(messageClear())  
//         } 
//         if (errorMessage) {
//             toast.error(errorMessage)
//             setPortionSize('')
//             dispatch(messageClear())  
//         } 
//     },[successMessage, errorMessage])

//     const responsive = {
//         superLargeDesktop:  { breakpoint: { max: 4000, min: 3000 }, items: 5 },
//         desktop:            { breakpoint: { max: 3000, min: 1024 }, items: 5 },
//         tablet:             { breakpoint: { max: 1024, min: 464 }, items: 4 },
//         mdtablet:           { breakpoint: { max: 991, min: 464 }, items: 4 },
//         mobile:             { breakpoint: { max: 464, min: 0 }, items: 3 },
//         smmobile:           { breakpoint: { max: 640, min: 0 }, items: 2 },
//         xsmobile:           { breakpoint: { max: 440, min: 0 }, items: 1 },
//     }

//     const [quantity, setQuantity] = useState(1)
//     const cartProductQuantityIncrementLocal = () => {
//         if (quantity >= product.stock) {
//             toast.error('Out of Stock')
//         } else {
//             setQuantity(quantity + 1)
//         }
//     }
//     const cartProductQuantityDecrementLocal = () => {
//         if (quantity > 1) {
//             setQuantity(quantity - 1)
//         }
//     }

//     const redirect_chat_page = (chatTopic) => {
//         if (userInfo) {
//             navigate(`/customerDashboard/chat/${chatTopic}`)
//         } else {
//             navigate('/login')
//         }
//     }
//     const add_to_cart_local = () => {
//         if (userInfo) {
//            dispatch(add_to_cart({
//             userId : userInfo.id,
//             quantity,
//             productId : product._id,
//             portionSize: portionSize
//            }))
//            setPortionSize('')
//         } else {
//             navigate('/login')
//         }
//     }

//     const add_to_cart_list_local = (prodID) => {
//         if (userInfo) {
//            dispatch(add_to_cart({
//             userId : userInfo.id,
//             quantity,
//             productId : prodID,
//             portionSize: portionSize
//            }))
//            setPortionSize('')
//         } else {
//             navigate('/login')
//         }
//     }

//     const add_to_wishlist_local = () => {
//         if (userInfo) {
//             dispatch(add_to_wishlist({
//                 userId: userInfo.id,
//                 productId: product._id,
//                 name: product.name,
//                 price: product.price,
//                 image: product.images[0],
//                 discount: product.discount,
//                 rating: product.rating,
//                 slug: product.slug,
//                 portionSizes: product.portionSizes,
//                 description: product.description,
//                 byThePan: product.byThePan
//             }))
//         } else {
//             navigate('/login')
//         }
//     }

//     const add_to_wishlist_list_local = (pro) => {
//         if (userInfo) {
//             dispatch(add_to_wishlist({
//                 userId: userInfo.id,
//                 productId: pro._id,
//                 name: pro.name,
//                 price: pro.price,
//                 image: pro.images[0],
//                 discount: pro.discount,
//                 rating: pro.rating,
//                 slug: pro.slug,
//                 portionSizes: pro.portionSizes,
//                 description: pro.description,
//                 byThePan: pro.byThePan
//             }))
//         } else {
//             navigate('/login')
//         }
//     }

//     return (        
//         <div>
//             <Header/>
//             <section>
//                 <div className='py-2 mb-2'
//                     style={{color:sellerPrimaryColor1}}>
//                     <div className='w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto'>
//                         <ShopBanner homePage={'Home'} homeLink={'/'} currentPageTop={sellerProductTerm  + ' Details'} currentPageTopLink={''} 
//                             currentPageBottom1={ product.category } currentPageBottomLink1={'/productsCategory?category=' + product.category} 
//                             currentPageBottom2={product.name} currentPageBottomLink2={''} />
//                         <div className='hidden justify-start items-center text-md w-full'>
//                             <Link to='/'>Home</Link>
//                             <span className='pt-1'><IoIosArrowForward /></span>
//                             <Link to='/'>{ product.category }</Link>
//                             <span className='pt-1'><IoIosArrowForward /></span>
//                             <span>{ product.name }</span>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//             <section>
//                 <div className='w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto'>
//                     <div className='grid grid-cols-2 md-lg:grid-cols-1 gap-4'>
//                         <div>
//                             <div className='p-5 border'>
//                                 { /* Image with Skeleton Loading image ? image : */ }
//                                 <img className='h-[320px]' src={product?.images?.[0]} alt={product.name} />
//                                 <div className='italic ' style={{color:sellerPrimaryColor1}}>
//                                     {sellerCompanyMarketingLine1}
//                                 </div>
//                             </div>
//                             <div className='py-3'>
//                                 {   
//                                     product.images && product.images?.[1] &&
//                                     <Carousel autoPlay={true} infinite={true} responsive={responsive} transitionDuration={500}>
//                                         { 
//                                             product.images.map((img, i) => {
//                                                 return (
//                                                     <div key={i} onClick={() => setImage(img)}>
//                                                         <SkeletonWithImage className='h-[120px] w-[100px] object-cover cursor-pointer' src={img} alt="" /> 
//                                                     </div>
//                                                 )
//                                             })
//                                         } 
//                                     </Carousel>
//                                 }
//                             </div>    
//                         </div>
//                         {
//                             // category:       { type: String, required : true },
//                             // mainIngredient: { type: String, required : true },
//                             // price:          { type: Number, required : false },
//                             // stock:          { type: Number, required : false },
//                             // discount:       { type: Number, required : false },
//                             // description:    { type: String, required : true },
//                             // shopName:       { type: String, required : true },
//                             // images:         { type: Array, required : true },
//                             // rating:         { type: Number, default : 0 },
//                             // allergies:      { type: String, required : false },
//                             // FMP:            { type: String, required : false },
//                             // portionSizes:   { type: String, required : false }
//                         }
//                         <div className='flex flex-col gap-2 border-none p-2 '>
//                             <div className='text-3xl font-bold'>
//                                 <h3 style={{color:sellerPrimaryColor1}}>{product.name}</h3>
//                             </div>
//                             <div className={` ${sellerBoolShowSiteRating ? '' : 'hidden'} flex justify-start items-center gap-2`}>
//                                 <div className='flex text-xl' >
//                                     <Rating ratings={4.5} />
//                                 </div>
//                                 <span className={` ${sellerBoolShowSiteProductReviews ? 'hidden' : 'hidden'} `} 
//                                     style={{color:sellerPrimaryColor1}}>(24 reviews)</span> 
//                             </div>
//                             <div className={` ${sellerBoolShowSitePayments ? 'text-2xl font-bold flex gap-2' : 'hidden'} `}
//                                 style={{color:sellerPrimaryColor1}}>
//                                 {
//                                     // discount !== 0 ? <>
//                                     // Price : <h2 className='line-through'>$500</h2>
//                                     // <h2>${500 - Math.floor((500 * discount) / 100)} (-{discount}%) </h2>
//                                     // </> : <h2> Price : $200 </h2>
//                                 }
//                                 Price: {currencyFormat.format(product.price)}
//                             </div>      
//                             <div className=''>
//                                 <textarea required name="" id="" cols="30" rows="5" 
//                                     className='border outline-0 w-full' 
//                                     style={{color:sellerPrimaryColor1}}
//                                     value={product.description} />
//                             </div>
//                             <div className='hidden gap-2 p-1 border font-semibold'
//                                 style={{color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                 {sellerCompanyMarketingLine1}
//                             </div>
//                             <div className='gap-2 p-1 border'
//                                 style={{color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                 <span className='font-semibold'>{sellerProductTerm} Details: </span>
//                                 <span className={` ${product.FMP === '' ? 'hidden' : ''} `}>
//                                     {product.FMP};
//                                 </span> 
//                                 <span className='ml-1 mr-1'>Category: <b>{product.category}</b>;</span>
//                                 <span className={` ${product.allergies !== 'None' ? 'ml-1 mr-1 font-semibold text-red-500' : ''} `}>
//                                     Allergies: <b>{product.allergies}</b>;
//                                 </span>
//                                 <span className={` ${sellerBoolShowSiteCookingMethods ? 'ml-1 mr-1' : 'hidden'} `}> 
//                                     Cooking Method: <b>{product.cookingMethod}</b>;
//                                 </span>
//                                 <span className={` ${product.byThePan === 'NoPan' ? 'hidden' : 'ml-1 mr-1'} `}>
//                                     By The Pan: <b>{product.byThePan}</b>
//                                 </span>
//                                 <span className={` ${product.dietaryRestrictions === 'None' ? 'hidden' : 'ml-1 mr-1'} `}>
//                                     Dietary Restrictions: <b>{product.dietaryRestrictions}</b>
//                                 </span>
//                                  <span className={` ${product.dietaryRestrictions === 'None' ? 'hidden' : 'ml-1 mr-1'} `}>
//                                     Dietary Restrictions: <b>{product.dietaryRestrictions}</b>
//                                 </span>
//                                 <span className={` ${sellerBoolShowCuisineType ? 'ml-1 mr-1' : 'hidden'} `}>
//                                     Cuisine Type: <b>{product.cuisineType}</b>
//                                 </span>
//                                 <span className={` ${sellerBoolShowSiteHoliday ? 'mr-1' : 'hidden'} `}>
//                                     <span className={` ${product.holiday === 'None' ? 'hidden' : 'mr-1'} `}>
//                                         Holiday: <b>{product.holiday}</b> 
//                                     </span>
//                                 </span>
//                             </div>
//                             {
//                                 //pl-2 w-full grid grid-cols-3 md-lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-2
//                                 //flex gap-2 pb-2 border-b
//                             }
//                             <div className={`grid grid-cols-2 md-lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1 gap-2`}>
//                                 <div>
//                                     <button onClick={() => add_to_cart_local(product._id)} 
//                                         className='px-1 py-1 h-[34px] flex w-full rounded-lg text-md cursor-pointer 
//                                         justify-center items-center text-white' 
//                                         style={{backgroundColor:sellerPrimaryColor1}}>
//                                         {
//                                             userInfo ? 
//                                             <><MdOutlineRestaurantMenu className='mr-1' /> Add To {sellerShoppingTerm}</>
//                                             : 
//                                             <><FaUser className='mr-1' /> Please Login Or Register</>
//                                         }
//                                     </button>
//                                 </div>
//                                 <div onClick={add_to_wishlist_local} style={{backgroundColor:sellerPrimaryColor1}}
//                                     className={` ${sellerBoolShowSiteWishList ? '' : 'hidden'}  
//                                     h-[34px] w-full rounded-lg flex justify-center items-center  
//                                     cursor-pointer text-white`}>
//                                     <FaHeart className='mr-1' />Add To Wishlist
//                                 </div>
//                             </div>
//                             { /*grid grid-cols-3 md-lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-2 flex py-2 gap-2*/ }
//                             <div className='grid grid-cols-2 md-lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-2'>
//                                 <div onClick={() => redirect_chat_page(product.name)}  
//                                     className={` ${sellerBoolShowSiteChat ? '' : 'hidden' } 
//                                     px-1 py-1 flex h-[34px] w-full justify-center items-center rounded-lg  
//                                     cursor-pointer text-white`}
//                                     style={{backgroundColor:sellerPrimaryColor1}}>
//                                     <IoChatbubbleEllipsesSharp className='mr-1' />Chat With Us
//                                 </div>
//                                 <div className={`${product.portionSizes !== '' ? '' : 'hidden'} `}>
//                                     <select onChange={(e) => setPortionSize(e.target.value)} id='' name='' 
//                                         className='flex border px-3 rounded-lg text-[13px] w-full h-[34px] font-semibold' 
//                                         style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                         <option value=''>Choose Portion Size</option>
//                                         {
//                                             product.portionSizes?.split(';').map((p,i) => {
//                                                 return( <option key={i} value={p}>{p}</option> )
//                                             })
//                                         }
//                                     </select>
//                                 </div> 
//                             </div>
//                             <div className='grid grid-cols-2 md-lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-2'>
//                                  <div className={` ${sellerBoolShowSiteProductQuantities ?  '' : 'hidden' } 
//                                     flex border rounded-lg w-[90px] h-[34px] ml-1 justify-center items-center `}
//                                     style={{borderColor:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                     <div onClick={cartProductQuantityDecrementLocal}  
//                                         className='px-2 cursor-pointer text-[15px] font-semibold' style={{color:sellerPrimaryColor1}}>-</div> 
//                                     <div className='px-2 text-[15px] font-semibold' style={{color:sellerPrimaryColor1}}>{quantity}</div> 
//                                     <div onClick={cartProductQuantityIncrementLocal}  
//                                         className='px-2 cursor-pointer text-[15px] font-semibold' style={{color:sellerPrimaryColor1}}>+</div> 
//                                 </div>                                
//                                 {/*onClick={redirect_chat_page}*/}
//                             </div>
//                             <div className='flex py-2 gap-2'>
//                                 <div className='w-[150px] text-black font-bold text-xl flex flex-col gap-5'>
//                                     <span className={` ${sellerBoolShowStock ? '' : 'hidden' } `}>
//                                         Availability
//                                     </span>
//                                     <span className={` ${sellerBoolShowSiteSocialMedia ? 'ml-4' : 'hidden' } `}
//                                         style={{color:sellerPrimaryColor1}}>
//                                         Share On
//                                     </span>
//                                 </div>
//                                 <div className={`flex flex-col gap-2`}>
//                                     <div className={` ${sellerBoolShowStock ? '' : 'hidden' } `}>
//                                         <span className={`text-${product.stock ? 'green' : 'red'}-500`}>
//                                             {product.stock ? `In Stock(${product.stock})` : 'Out Of Stock'}
//                                         </span>
//                                     </div>
//                                     <div className={` ${sellerBoolShowSiteSocialMedia ? '' : 'hidden' } `}>
//                                         <ul className='flex justify-start items-center gap-3'>
//                                             <li>
//                                                 <a className='w-[38px] h-[38px] hover:bg-[#059473] hover:text-white flex justify-center items-center bg-indigo-500 rounded-full text-white' href="#">
//                                                     <FaFacebookF />
//                                                 </a>
//                                             </li>
//                                             <li>
//                                                 <a className='w-[38px] h-[38px] hover:bg-[#059473] hover:text-white flex justify-center items-center bg-cyan-500 rounded-full text-white' href="#">
//                                                     <FaTwitter />
//                                                 </a>
//                                             </li>
//                                             <li>
//                                                 <a className='w-[38px] h-[38px] hover:bg-[#059473] hover:text-white flex justify-center items-center bg-purple-500 rounded-full text-white' href="#">
//                                                     <FaLinkedin />
//                                                 </a>
//                                             </li>
//                                             <li>
//                                                 <a className='w-[38px] h-[38px] hover:bg-[#059473] hover:text-white flex justify-center items-center bg-blue-500 rounded-full text-white' href="#">
//                                                     <FaGithub />
//                                                 </a>
//                                             </li>
//                                         </ul> 
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className='flex gap-3'>
//                                 <button className='hidden px-8 py-3 mb-2 h-[50px] cursor-pointer hover:shadow-lg 
//                                     hover:shadow-green-500/40 text-white'
//                                     style={{backgroundColor:sellerPrimaryColor1}}>
//                                     Event Details
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div> 
//             </section>
//             <section>
//                 <div className={` ${sellerBoolShowSiteProductReviews ? '' : 'hidden' } 
//                     w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto `}>
//                     {
//                         //w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto pb-16
//                         //
//                     }
//                     <div className='flex flex-wrap  border-none border-black'>
//                         <div className='w-[75%] md-lg:w-full border-none border-red-500'>
//                             <div>
//                                 <Reviews product={product} />
//                             </div> 
//                             <div className='pr-4 md-lg:pr-0'>
//                                 <div className='grid grid-cols-2'>
//                                     <span 
//                                         className='hidden py-1 px-5 border font-bold text-md' 
//                                         style={{color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                                         Reviews
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className='w-[25%] md-lg:w-full border-none border-green-700'>
//                             <div className={` ${moreProducts.length === 0 ? 'hidden' : ''} pl-1 md-lg:pl-0`}>
//                                <Products
//                                     title={`From Our Menu`}
//                                     products={chunkArray(moreProducts, 3)}  // ← 3 items per "page"
//                                     parentPage='productDetails'
//                                 />
//                             </div>

//                             {
//                             // <div className={` ${moreProducts.length === 0 ? 'hidden' : 'hidden'} pl-1 md-lg:pl-0`}>
//                             //     <div className='px-3 py-1 border mt-8'
//                             //         style={{color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                             //         <h2 className='font-bold h-[24px]'>From Our Menu</h2>
//                             //     </div>
//                             //     <div className='flex flex-col gap-3 mt-1 border p-3 mb-2'
//                             //         style={{color:sellerPrimaryColor1,  borderColor:sellerPrimaryColor1}}>
//                             //         {
//                             //             //, backgroundColor:sellerSecondaryColor1 style={{borderColor:sellerPrimaryColor1}}
//                             //             moreProducts.map((p,i) => {
//                             //                 return (
//                             //                     <div key={i} className='block'>
//                             //                         {
//                             //                             //console.log(moreProducts)
//                             //                             // <div key={j} 
//                             //                             // className='flex mt-2 justify-start items-start transition-all duration-1000 hover:-translate-y-3 flex-col'>
//                             //                             // <div className={` w-full relative group h-[210px] md:h-[270px] xs:h-[170px] overflow-hidden `} >
//                             //                         }
//                             //                         <div className='flex mt-0 border-2 justify-start items-start transition-all duration-1000 hover:-translate-y-2 flex-col' 
//                             //                             style={{color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                             //                             <div className='w-full relative group h-[154px] md:h-[270px] xs:h-[170px] overflow-hidden'>
//                             //                                 <SkeletonWithImage className='w-full h-[200px] border object-cover' src={p.images[0]} alt="" /> 
//                             //                                 <ul className='flex transition-all duration-700 -bottom-10 justify-center items-center gap-2 absolute w-full group-hover:bottom-3'>
//                             //                                     {/* hover:rotate-[720deg] bg-white hover:bg-[#059473] hover:text-white */}
//                             //                                     <li onClick={() => add_to_cart_list_local(p._id)} 
//                             //                                         className={` w-[38px] h-[38px] cursor-pointer flex border justify-center items-center rounded-full transition-all `}
//                             //                                         style={{backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                             //                                         <div className="icon-container">
//                             //                                             <span className='icon flex justify-center items-center'>
//                             //                                                 +<MdOutlineRestaurantMenu />&nbsp;
//                             //                                             </span>
//                             //                                             <div className="tooltip" style={tooltipHoverStyle}>Add To<br />{sellerShoppingTerm}</div>
//                             //                                         </div>
//                             //                                     </li>
//                             //                                     <li onClick={() => add_to_wishlist_list_local(p)} 
//                             //                                         className={` ${sellerBoolShowSiteWishList ? '' : 'hidden'} 
//                             //                                         w-[38px] h-[38px] cursor-pointer flex border justify-center items-center rounded-full transition-all`}
//                             //                                         style={{backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                             //                                         <div className="icon-container">
//                             //                                             <span className='icon flex justify-center items-center'>
//                             //                                                 &nbsp;<FaHeart />&nbsp;
//                             //                                             </span>
//                             //                                             <div className="tooltip" style={tooltipHoverStyle}>Add To<br />Wishlist</div>
//                             //                                         </div>                                                                    
//                             //                                     </li>
//                             //                                     <Link onClick={() => openModal(p)} 
//                             //                                         className={` w-[38px] h-[38px] cursor-pointer flex border justify-center items-center rounded-full transition-all`}
//                             //                                         style={{backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                             //                                         <div className="icon-container">
//                             //                                             <span className='icon flex justify-center items-center'>
//                             //                                                 &nbsp;<FaEye />&nbsp;
//                             //                                             </span>
//                             //                                             <div className="tooltip" style={tooltipHoverStyle}>Quick<br />View</div>
//                             //                                         </div>
//                             //                                     </Link>
//                             //                                     <li onClick={() => redirect_chat_page(p.name)}
//                             //                                         className={`w-[38px] h-[38px] cursor-pointer flex border justify-center items-center rounded-full transition-all`}
//                             //                                         style={{backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                             //                                         <div className="icon-container">
//                             //                                             <span className='icon flex justify-center items-center'>
//                             //                                                 &nbsp;<IoChatbubbleEllipsesSharp />&nbsp;
//                             //                                             </span>
//                             //                                             <div className="tooltip" style={tooltipHoverStyle}>Chat<br />With Us</div>
//                             //                                         </div>
//                             //                                     </li>
//                             //                                 </ul>
//                             //                                 {
//                             //                                     // p.discount !== 0 && 
//                             //                                     // <div className='flex justify-center items-center absolute text-white w-[38px] h-[38px] rounded-full bg-red-500 font-semibold text-xs left-2 top-2'>
//                             //                                     //     {p.discount}%
//                             //                                     // </div>
//                             //                                 }
//                             //                             </div>
//                             //                             <div className='py-1 font-bold ml-1' style={{color:sellerPrimaryColor1}}>
//                             //                                 {p.name}
//                             //                             </div>
//                             //                             <div className='flex gap-2 ml-1'  style={{color:sellerPrimaryColor1}}>
//                             //                                 <div className={` ${sellerBoolShowSitePayments ? 'text-lg font-bold' : 'hidden'} `}>
//                             //                                     {currencyFormat.format(p.price)}
//                             //                                 </div>
//                             //                                 <div className={` ${sellerBoolShowSiteRating ? 'flex items-center gap-2' : 'hidden'} `}>
//                             //                                     <Rating ratings={p.rating}  />
//                             //                                 </div>
//                             //                             </div>
//                             //                             <div className={`${p.portionSizes !== '' ? 'w-full' : 'hidden'} `}>
//                             //                                 <select onChange={(e) => setPortionSize(e.target.value)} id='' name='' 
//                             //                                     className='border rounded-md px-3 m-1 w-[97%] text-[14px] font-semibold' 
//                             //                                     style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                             //                                     <option value=''>Choose Portion Size</option>
//                             //                                     {
//                             //                                         p.portionSizes.split(';').map((p,i) => {
//                             //                                             return( <option key={i} value={p}>{p}</option> )
//                             //                                         })
//                             //                                     }
//                             //                                 </select>
//                             //                             </div>
//                             //                             <div className={`${p.portionSizes === '' ? 'w-full' : 'hidden'} `}>
//                             //                                 <div className={`${p.portionSizes === '' ? 'py-1 px-1 m-1 w-[97%] border text-[14px] font-semibold' : 'hidden'} `}
//                             //                                     style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
//                             //                                     {p.description?.substring(0, 32)} ...
//                             //                                 </div>
//                             //                             </div>
//                             //                             <div className='w-full justify-center items-center' >
//                             //                                  <button onClick={() => add_to_cart_local(p._id)} 
//                             //                                     className='px-1 py-1 m-1 h-[34px] flex w-[97%] rounded-lg text-md cursor-pointer 
//                             //                                     justify-center items-center hover:shadow-lg hover:shadow-green-500/40] text-white' 
//                             //                                     style={{backgroundColor:sellerPrimaryColor1}}>
//                             //                                     {
//                             //                                         userInfo ? 
//                             //                                         <><MdOutlineRestaurantMenu className='mr-1' /> Add To {sellerShoppingTerm}</>
//                             //                                         : 
//                             //                                         <><FaUser className='mr-1' /> Please Login Or Register</>
//                             //                                     }
//                             //                                 </button> 
//                             //                             </div>
//                             //                         </div>
//                             //                     </div>
//                             //                 )
//                             //             })
//                             //         }
//                             //     </div>
//                             // </div>
//                             }


//                         </div>
//                     </div>
//                 </div>
//             </section>

//             <section>
//                 <SwiperProducts
//                     title={`Related ${sellerProductPluralTerm} You Might Like`}
//                     products={relatedProducts} suppressToasts={true}
//                 />
//             </section>
          
//             <Footer/> 
            
//         </div>
//     );
// };

// export default Details;




//{/* start of old relatedProducts   */}
//            {
            // <section>
            //     <div className={` ${relatedProducts.length === 0 ? 'hidden' : ''}   w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto`}>
            //         <h2 className='text-2xl py-2 pl-3 border mb-2'
            //             style={{color:sellerPrimaryColor1,  borderColor:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
            //             Related {sellerProductPluralTerm}
            //         </h2>
            //         <div>
            //             <Swiper
            //                 slidesPerView='auto'
            //                 breakpoints={{ 1280 : { slidesPerView: 3 }, 565 :  { slidesPerView: 2 } }}
            //                 spaceBetween={10} loop={true}
            //                 pagination={{ clickable: true, el: '.custom_bullet' }}
            //                 modules={[Pagination]} className='mySwiper'> 
            //                 {
            //                     relatedProducts.map((p, i) => {
            //                         return (
            //                             <SwiperSlide key={i}>
            //                                 <div className='block border-2'
            //                                     style={{color:sellerPrimaryColor1,  borderColor:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
            //                                     <div  className={` w-full relative group h-[210px] md:h-[270px] xs:h-[170px] overflow-hidden `} >
            //                                         <SkeletonWithImage className='w-full h-[270px] object-cover' src={p.images[0] } alt="" />
            //                                         <ul className={`flex transition-all duration-700 -bottom-10 justify-center items-center gap-2 absolute w-full group-hover:bottom-3`}>
            //                                             {/*  hover:bg-[#059473] hover:text-white hover:rotate-[720deg] */}
            //                                             <li onClick={() => add_to_cart_list_local(p._id)} 
            //                                                 className='w-[38px] h-[38px] cursor-pointer border bg-white flex justify-center items-center rounded-full transition-all'
            //                                                 style={{backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
            //                                                 <div className="icon-container">
            //                                                     <span className='icon flex justify-center items-center'>
            //                                                         +<MdOutlineRestaurantMenu />&nbsp;
            //                                                     </span>
            //                                                     <div className="tooltip" style={tooltipHoverStyle}>Add To<br />{sellerShoppingTerm}</div>
            //                                                 </div>
            //                                             </li>
            //                                             <li onClick={() => add_to_wishlist_list_local(p)}
            //                                                 className={` ${sellerBoolShowSiteWishList ? '' : 'hidden'} 
            //                                                 w-[38px] h-[38px] cursor-pointer border bg-white flex justify-center items-center rounded-full transition-all`}
            //                                                 style={{backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
            //                                                 <div className="icon-container">
            //                                                     <span className='icon flex justify-center items-center'>
            //                                                         &nbsp;<FaHeart />&nbsp;
            //                                                     </span>
            //                                                     <div className="tooltip" style={tooltipHoverStyle}>Add To<br />Wishlist</div>
            //                                                 </div>
            //                                             </li>
            //                                             <li>
            //                                                 <Link onClick={() => openModal(p)} 
            //                                                     className='w-[38px] h-[38px] cursor-pointer border flex justify-center items-center rounded-full transition-all'
            //                                                     style={{backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
            //                                                     <div className="icon-container">
            //                                                         <span className='icon flex justify-center items-center'>
            //                                                             &nbsp;<FaEye />&nbsp;
            //                                                         </span>
            //                                                         <div className="tooltip" style={tooltipHoverStyle}>Quick<br />View</div>
            //                                                     </div>
            //                                                 </Link>
            //                                             </li>
            //                                             <li onClick={() => redirect_chat_page(p.name)}
            //                                                 className={` ${sellerBoolShowSiteChat ? '' : 'hidden'} 
            //                                                 w-[38px] h-[38px] cursor-pointer bg-white border flex justify-center items-center rounded-full transition-all` }
            //                                                 style={{backgroundColor:'white', color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
            //                                                 <div className="icon-container">
            //                                                     <span className='icon flex justify-center items-center'>
            //                                                         &nbsp;<IoChatbubbleEllipsesSharp />&nbsp;
            //                                                     </span>
            //                                                     <div className="tooltip" style={tooltipHoverStyle}>Chat<br />With Us</div>
            //                                                 </div>
            //                                             </li>
            //                                         </ul>
            //                                     </div>
            //                                     <div className='p-1 flex flex-col gap-1' style={{color:sellerPrimaryColor1}}>
            //                                         <div className='text-lg font-bold'>{p.name}</div>
            //                                         <div className='flex justify-start items-center gap-3'>
            //                                             <div className={` ${sellerBoolShowSitePayments ? 'text-lg font-bold' : 'hidden'} `}>
            //                                                 {currencyFormat.format(p.price)}
            //                                             </div>
            //                                             <div className={` ${sellerBoolShowSiteRating ? 'flex' : 'hidden'} `}>
            //                                                 <Rating ratings={p.rating}  />
            //                                             </div>
            //                                         </div>
            //                                     </div>

            //                                     <div className={`${p.portionSizes !== '' ? 'w-full' : 'hidden'} `}>
            //                                         <select onChange={(e) => setPortionSize(e.target.value)} id='' name='' 
            //                                             className='border rounded-md px-3 m-1 w-[97%] h-[28px] text-[14px] font-semibold' 
            //                                             style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
            //                                             <option value=''>Choose Portion Size</option>
            //                                             {
            //                                                 p.portionSizes.split(';').map((p,i) => {
            //                                                     return( <option key={i} value={p}>{p}</option> )
            //                                                 })
            //                                             }
            //                                         </select>
            //                                     </div>
            //                                     <div className={`${p.portionSizes === '' ? 'w-full' : 'hidden'} `}>
            //                                         <div className={`${p.portionSizes === '' ? 'py-1 px-1 m-1 w-[97%] border text-[14px] font-semibold' : 'hidden'} `}
            //                                             style={{borderColor:sellerPrimaryColor1, color:sellerPrimaryColor1, backgroundColor:sellerSecondaryColor1}}>
            //                                             {p.description?.substring(0, 32)} ...
            //                                         </div>
            //                                     </div>
            //                                     <div className='w-full justify-center items-center' > 
            //                                         <button onClick={() => add_to_cart_local(p._id)} 
            //                                             className='px-1 py-1 m-1 h-[34px] flex w-[97%] rounded-lg text-md cursor-pointer 
            //                                             justify-center items-center hover:shadow-lg hover:shadow-green-500/40] text-white' 
            //                                             style={{backgroundColor:sellerPrimaryColor1}}>
            //                                             {
            //                                                 userInfo ? 
            //                                                 <><MdOutlineRestaurantMenu className='mr-1' /> Add To {sellerShoppingTerm}</>
            //                                                 : 
            //                                                 <><FaUser className='mr-1' /> Please Login Or Register</>
            //                                             }
            //                                         </button> 
            //                                     </div>
            //                                 </div>
            //                             </SwiperSlide>
            //                         )
            //                     })
            //                 }
            //             </Swiper>
            //         </div>
            //         <div className='w-full flex justify-center items-center py-8'>
            //             <div className='custom_bullet justify-center gap-3 !w-auto'> 
            //             </div>            
            //       </div>
            //     </div>
            // </section>
            //}
            //{/* end of old relatedProducts  */}
            
